import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const CtaBanner = () => {
  return (
    <section
      data-testid="cta-banner"
      className="relative bg-[#2D3A2B] py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-10 text-center relative z-10">
        <p className="text-xs tracking-[0.35em] uppercase text-[#C6A692] mb-6">
          Begin
        </p>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#FDFCFB] leading-tight">
          Ready to take the first{" "}
          <span className="italic text-[#C6A692]">grounded</span> step?
        </h2>
        <p className="mt-8 text-lg text-[#C6BFB4] leading-relaxed max-w-2xl mx-auto font-light">
          A consultation is where we listen. To your goals, your body, and the
          patterns asking for balance. Reach out to schedule your assessment.
        </p>
        <div className="mt-12">
          <Link to="/contact" data-testid="cta-banner-book">
            <Button className="rounded-full bg-[#C6A692] hover:bg-[#B99783] text-[#2D3A2B] px-10 py-6 h-auto text-base font-medium group">
              Book Your Consultation
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
        </div>
      </div>
      <div className="absolute top-0 left-1/4 w-72 h-72 rounded-full bg-[#8A9A83]/20 blur-3xl" aria-hidden />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 rounded-full bg-[#C6A692]/10 blur-3xl" aria-hidden />
    </section>
  );
};

export default CtaBanner;
